import api from "../axios_service.js";

export function putAprovacaoMidiaSocialCalendario(id, midia) {
  let body = {};
  for (let key in midia) {
    body[key] = midia[key];
  }
  return api.put(`/clientes-calendarios-aprovado/${id}`, body);
}